import { 
    ACTUALIZAR_LIST_CATEGORIASRRHH,
    AGREGAR_CATEGORIASRRHH,
    MODIFICAR_CATEGORIASRRHH,
  } from "./categoriasRRHHActions";

  const CategoriasRRHHReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_CATEGORIASRRHH: {
            return {
                ...state,
                categoriasRRHHList: action.payload
            }
        };

        case AGREGAR_CATEGORIASRRHH:{
            return {
                 ...state,
                 categoriasRRHHList: [action.payload, ...state.categoriasRRHHList]
             }
         };

        case MODIFICAR_CATEGORIASRRHH: {
            return {
                ...state,
                categoriasRRHHList: state.categoriasRRHHList.map((g) => g._id === action.payload._id ? action.payload : g)
            }
        };

        default: return state;
    }
  }

  export default CategoriasRRHHReducer;